import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 历史小票列表中获取品牌数据
 */
export const fetchBrandList = async () => {
    const res = await GET(APIs.API_BASIC_GETBRANDLIST);

    return res.data.data ?? {};
};

/**
 * 销售渠道
 */
export const fetchSalesSource = async () => {
    const res = await GET(APIs.API_BASIC_GETSALESSOURCE);

    return res.data.data ?? {};
};

/**
 * 小票中获取拒绝原因
 */
export const fetchRefuseDesc = async () => {
    const res = await GET(APIs.API_BASIC_GETREFUSEDESC);

    return res.data.data ?? {};
};